import script from "./SelfReportPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SelfReportPanel.vue?vue&type=script&setup=true&lang=js"

import "./SelfReportPanel.vue?vue&type=style&index=0&id=cb22682a&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb22682a"]])

export default __exports__